module.exports = __webpack_public_path__ + "static/media/HomeLowCost.267e384b.svg";